export * from './info.module';

export * from './about/about.component';
export * from './add-homescreen-android/add-homescreen-android.component';
export * from './add-homescreen-ios/add-homescreen-ios.component';
// export * from './add-super-fund/add-super-fund.component';
export * from './disclaimer/disclaimer.component';
export * from './disclaimer/disclaimer-dialog/disclaimer-dialog.component';
export * from './enable-cookies/enable-cookies.component';
